import { useScanDeviceApiUpsert } from '@hooks/api/useScanDeviceApiUpsert';
import type { VrsAccount, VrsAccountUpsertInput } from 'types/api';

export const useVrsAccountUpsert = useScanDeviceApiUpsert<VrsAccount, VrsAccountUpsertInput>(
  '/vrs-accounts',
);
